import React from 'react';
import { Datalist } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@agissc/ktag-map';
import IdentifyMessageBox from './IdentifyMessageBox';
import useAppState from '../../../AppStore';

interface IdentifyGeneralInfoResultProps {
  coordinate: string;
  municipality: string;
  elevation: string;
  address: string;
  parcel: string;
  inKantonAG: boolean;
}

const IdentifyGeneralInfoResult = ({
  coordinate,
  municipality,
  elevation,
  address,
  parcel,
  inKantonAG,
}: IdentifyGeneralInfoResultProps) => {
  const { t } = useTranslation('agisviewer');
  const identifyCoordinate = useAppState((state) => state.identifyCoordinate);
  const setLocation = useAppState((state) => state.setLocation);

  const handleZoomToCoordinate = () => {
    if (identifyCoordinate) {
      setLocation({ center: { x: identifyCoordinate[0], y: identifyCoordinate[1] } });
    }
  };

  const coordinateItem = {
    key: `${t('coordinate')}:`,
    value: (
      <div className="coordinate-wrapper">
        <span className="coordinate-label">{coordinate}</span>
        <IconButton
          icon="map-marker"
          title={t('search_results_subtitle_location')}
          onClick={handleZoomToCoordinate}
          additionalClassNames="result-item__button-icon"
        />
      </div>
    ),
  };

  const otherItems = inKantonAG
    ? [
        {
          key: `${t('gg25')}:`,
          value: municipality,
        },
        {
          key: `${t('elevation')}:`,
          value: elevation,
        },
        {
          key: `${t('address')}:`,
          value: address,
        },
        {
          key: `${t('parcel')}:`,
          value: parcel,
        },
      ]
    : [];

  return (
    <>
      <Datalist items={[coordinateItem, ...otherItems]} smallkeys />
      {!inKantonAG && (
        <IdentifyMessageBox message={t('identify_notInAG_message')} type="information" />
      )}
    </>
  );
};

export default IdentifyGeneralInfoResult;
